export enum AuthActionTypeEnum {
    InitAuthState = "INIT_MAIN_STATE"
}
